import axios from "axios";
import Cookies from "js-cookie";

let baseURL = "";

if (process.env.NODE_ENV === "production") {
  baseURL = "https://boyo.mn";
} else {
  baseURL = "https://boyo.mn";
  // baseURL = "http://localhost";
}

// let config = {
//   method: 'post',
//   maxBodyLength: Infinity,
//   url: 'https://boyo.mn/bowsys/backend/allAccount',
//   headers: { 
//     'bowsystoken': 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImVua2hib2xkenVAZ21haWwuY29tIiwiaWF0IjoxNzQ3MDMyMTcyLCJleHAiOjE3NDcwMzU3NzJ9.B1ZTEQ7tUZGpoz2EB94q0s2nPFnS-aNRAVrgTIGBKcc', 
//     'Cookie': 'connect.sid=s%3ADbfHCTr0ZLfOfgP8jg0cHIqs8ICaKy-1.o3VRfL7wpUTES5Iw1G4c2gOkpJBiVLTzwNqWmmTrHt8'
//   },
//   data : data
// };

const instance = axios.create({
  baseURL: `${baseURL}/bowsys/backend`,
  headers: {
    "Access-Control-Allow-Origin": "*",
    'bowsystoken':  Cookies.get("bowsystoken")
  },
  withCredentials: true,
});

const clientInstance = axios.create({
  baseURL: `${baseURL}/backend`,
});

export { instance, clientInstance };
